
import { useOptimizedAuth } from "@/hooks/useOptimizedAuth";
import { Navigate } from "react-router-dom";
import Header from '@/components/header/ModernHeader';
import Footer from "@/components/Footer";
import { SEO } from "@/components/SEO";
import AddressSettings from "@/components/settings/AddressSettings";
import BackButton from "@/components/navigation/BackButton";

const Addresses = () => {
  const { user, loading } = useOptimizedAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-light">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <>
      <SEO title="My Addresses" description="Manage your shipping and billing addresses." />
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto">
            <BackButton to="/profile" label="Back to Profile" />
            <h1 className="text-3xl font-bold mb-8">My Addresses</h1>
            <AddressSettings />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Addresses;
